module.exports = __webpack_public_path__ + "static/media/exercises-step3.978251de.png";